module.exports = __webpack_public_path__ + "img/peru.5b8c381f.svg";